import {useQueryClient} from '@tanstack/react-query';
import {
  GetLinkedInAdAccounts,
  QueueImportLinkedInAdAccounts,
} from '../../shared/api/definitions/integration';
import {createApiQuery, useApiMutation} from './api';
import {TaskStatusQueryKeys} from './tasks';

const LinkedInQueryKeys = {
  all: ['linkedin'] as const,
  adAccounts: () => [...LinkedInQueryKeys.all, 'adAccounts'] as const,
};

export const useGetAdAccounts = createApiQuery(
  GetLinkedInAdAccounts,
  () => LinkedInQueryKeys.adAccounts(),
  {staleTime: Infinity}
);

export const useQueueImportLinkedInAdAccounts = () => {
  const queryClient = useQueryClient();
  return useApiMutation(QueueImportLinkedInAdAccounts, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: TaskStatusQueryKeys.task('importLinkedInAdAccounts'),
      });
    },
  });
};
